import { createSvgIcon } from '@mui/material/utils';

export default createSvgIcon(
  <g fillRule="nonzero" fill="none">
    <path d="M8 24a4 4 0 004-4v-4H8a4 4 0 000 8z" fill="#0ACF83" />
    <path d="M4 12a4 4 0 014-4h4v8H8a4 4 0 01-4-4z" fill="#A259FF" />
    <path d="M4 4a4 4 0 014-4h4v8H8a4 4 0 01-4-4z" fill="#F24E1E" />
    <path d="M12 0h4a4 4 0 010 8h-4V0z" fill="#FF7262" />
    <path d="M20 12a4 4 0 11-8 0 4 4 0 018 0z" fill="#1ABCFE" />
  </g>,
  'Figma',
);
